import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HeroSection() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useScrollReveal(0.1);
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useScrollReveal(0.1);
  return <section className="relative w-full min-h-screen flex items-center overflow-hidden pt-12" style={{
    background: 'linear-gradient(160deg, #0D1B2A 0%, #0f1e2e 50%, #0D1B2A 100%)'
  }} data-id="element-137">
      {/* Warm ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,168,83,0.06) 0%, transparent 70%)'
    }} data-id="element-138" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-14 lg:py-28" data-id="element-139">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-140">
          {/* Text content */}
          <div ref={textRef} className={`reveal ${textVisible ? 'visible' : ''} text-center lg:text-left`} data-id="element-141">
            {/* Headline */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-6" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8'
          }} data-id="element-142">
              Ton cerveau ne s'arrête jamais.{' '}
              <span style={{
              color: '#D4A853'
            }} data-id="element-143">
                Même quand toi, tu n'en peux plus.
              </span>
            </h1>

            {/* Sub-headline */}
            <h2 className="text-lg md:text-2xl font-normal mb-8 md:mb-10 leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#C8C0B0',
            fontStyle: 'italic'
          }} data-id="element-144">
              La Méthode OFF : 10 minutes ce soir pour éteindre la charge
              mentale. Pour de vrai.
            </h2>

            {/* CTA Button */}
            <div className="flex flex-col items-center lg:items-start gap-2" data-id="element-145">
              <button onClick={() => {
              document.getElementById('offer-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="cta-pulse inline-flex items-center gap-2 px-8 py-5 rounded-xl text-base md:text-lg font-semibold transition-transform hover:scale-105 active:scale-95" style={{
              background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
              color: '#0D1B2A',
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 600
            }} data-id="element-146">
                👉 J'APPUIE SUR OFF
              </button>
              <p className="text-sm font-medium text-center" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-147">
                [ Accès immédiat ]
              </p>
            </div>
          </div>

          {/* Product image */}
          <div ref={imgRef} className={`reveal reveal-delay-2 ${imgVisible ? 'visible' : ''} flex justify-center lg:justify-end`} data-id="element-148">
            <div className="relative" data-id="element-149">
              {/* Warm glow behind image */}
              <div className="absolute inset-0 rounded-2xl -m-4" style={{
              background: 'radial-gradient(ellipse, rgba(212,168,83,0.15) 0%, transparent 70%)',
              filter: 'blur(20px)'
            }} data-id="element-150" />
              <img src="https://cdn.magicpatterns.com/uploads/kWvrTGrS4emBLZLxjhCLwG/COVER_LA_METHODE_OFF.png" alt="La Méthode OFF — 10 Minutes pour Retrouver le Silence Mental" className="relative z-10 w-full max-w-md lg:max-w-full rounded-2xl" style={{
              boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 40px rgba(212,168,83,0.15)'
            }} data-id="element-151" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent, #0D1B2A)'
    }} data-id="element-152" />
    </section>;
}